import moment from 'moment';

const hexToRgb = hex => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      }
    : null;
};

const ucFirst = string => string.charAt(0).toUpperCase() + string.slice(1);

const getRandomIntInclusive = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min; //Il max è incluso e il min è incluso
};

const sortDate = (d1, d2, direction = 'DESC') => {
  return moment(d1).isAfter(d2) ? (direction === 'DESC' ? -1 : 1) : moment(d1).isBefore(d2) ? (direction === 'DESC' ? 1 : -1) : 0;
};

const getRenderedToReplace = html => {
  const pass1 = [...html.matchAll(/data-replace-render="([^"]+)"/g)].shift()[1];
  const Entities = require('html-entities').XmlEntities;
  const entities = new Entities();
  const pass2 = entities.decode(pass1);
  return JSON.parse(pass2);
};

export default { hexToRgb, ucFirst, getRandomIntInclusive, sortDate, getRenderedToReplace };



// WEBPACK FOOTER //
// ./src/helpers/utils.js